import { HoverCard, HoverCardContent, HoverCardTrigger } from '@chain-zen/ui'

import type { IAPISourceProps } from '../types'
import { APIInfo } from './api-info'
import { APITooltip } from './api-tooltip'

/**
 * APISource displays the API tracking data for the shipment.
 */
export const APISource = (props: IAPISourceProps) => {
  const { trackingSourceData, shipmentID } = props

  return (
    <HoverCard>
      <HoverCardTrigger className="w-full">
        <div className="w-full">
          <APIInfo trackingSourceData={trackingSourceData} shipmentID={shipmentID} />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-full text-sm" side="top">
        <APITooltip trackingSourceData={trackingSourceData} />
      </HoverCardContent>
    </HoverCard>
  )
}
